import { connect } from 'react-redux';

import React from 'react';
import { Header, Segment, Image, Grid, Container } from 'semantic-ui-react';

import header_image from '../Resources/trilogy-logo@3x.png';

class PageHeaderView extends React.Component {
  constructor() {
    super();
    this.state = {
      image_load_failed: false,
    };
  }

  render() {
    const header = this.props.header || '';

    /*
    var user_info;
    if (this.props.fetchingUserInfo) {
      user_info = <Loader active>Fetching User Info</Loader>;
    } else if (this.props.errorFetchingUserInfo) {
      user_info = (
        <Header as="h4" color="blue">
          <Header.Content>Login Failed: {this.props.error}</Header.Content>
          <br />
          {help_menu_popup}
        </Header>
      );
    } else {
      user_info = (
        <Header as="h4" color="blue">
          {avatar_image}
          <Header.Content>Welcome {this.props.LoggedUserName}!</Header.Content>
          <br />
          {help_menu_popup}
        </Header>
      );
    }
    */

    return (
      <React.Fragment>
        <Segment inverted color="blue">
          <Grid columns="equal">
            <Grid.Column verticalAlign="middle">
              <Image src={header_image} as="a" floated="left" size="small" />
            </Grid.Column>

            <Grid.Column
              verticalAlign="middle"
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
            >
              <Header as="h1" style={{ color: 'white', fontFamily: 'calibri', fontWeight: 375 }}>
                <Header.Content>{header}</Header.Content>
              </Header>
            </Grid.Column>

            <Grid.Column verticalAlign="middle">
              <Container textAlign="right">{/*user_info*/}</Container>
            </Grid.Column>
          </Grid>
        </Segment>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    header: ownProps.header,
  };
};

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export const PageHeader = connect(mapStateToProps, mapDispatchToProps)(PageHeaderView);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/Components/PageHeader.jsx